// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const crabominable: PokeData = {
  "id": 740,
  "name": "crabominable",
  "height": 17,
  "weight": 1800,
  "base_experience": 167,
  "types": [
    PokeType.FIGHTING,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-punch",
    "slam",
    "leer",
    "bubble-beam",
    "bubble",
    "dizzy-punch",
    "reversal",
    "protect",
    "dynamic-punch",
    "pursuit",
    "rock-smash",
    "brick-break",
    "iron-defense",
    "close-combat",
    "avalanche",
    "power-up-punch",
    "ice-hammer"
  ],
  "moves": [
    "ice-punch",
    "leer",
    "bubble-beam",
    "bubble",
    "protect",
    "pursuit",
    "rock-smash",
    "close-combat",
    "avalanche",
    "blizzard",
    "icicle-dagger",
    "meteor-assault",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 380,
    "item": null,
    "species": [
      {
        "name": "crabrawler",
        "order": 739,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "crabominable",
        "order": 740,
        "types": [
          PokeType.FIGHTING,
          PokeType.ICE
        ],
        "evolves_from_species_id": 739,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": {
              "name": "mount-lanakila"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 66,
    "ability_power": 203
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
